import { render } from "./Page16.vue?vue&type=template&id=3dd4a3bb"
import script from "./Page16.vue?vue&type=script&lang=js"
export * from "./Page16.vue?vue&type=script&lang=js"

import "./Page16.vue?vue&type=style&index=0&id=3dd4a3bb&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__